




























import Vue from "vue";
import IconBase from "@/components/common/IconBase.vue";
import Icons from "@/components/icons/Icons.vue";
import TitleH2 from "@/components/common/TitleH2.vue";

export default Vue.extend({
  name: "Advantages",
  props: {
    items: { type: Array, default: () => [] },
    title: String,
  },
  components: {
    IconBase,
    Icons,
    TitleH2,
  },
  data() {
    return {
      viewBox: "0 0 64 64",
      width: 64,
      height: 64,
      color: "#ffc000",
    };
  },
});
